<template>
  <el-aside class="the-aside" :class="opened ? 'the-aside__opened' : ''">
    <div class="the-aside__content">

      <div class="logo">
        <icon-logo color="#32E6BE"/>
        <transition name="fade">
          <div v-if="opened">
            <span class="logo__wrapper" :style="{width: opened ? 'auto' : '20px'}">ARM - врача</span>
          </div>
        </transition>
      </div>

      <el-menu
          @select="goPage"
          class="el-menu-vertical"
          :collapse="!opened"
          :default-active="activeMenu"
          text-color="#b3b3b3"
          active-text-color="#32E6BE"
      >

        <el-menu-item index="cpanel.dashboard" name="dashboard">
          <i class="el-icon-s-data"></i>
          <span slot="title">Дашборд</span>
        </el-menu-item>
        <el-menu-item index="session" name="session" v-if="features('screening_plus')">
          <i class="el-icon-first-aid-kit"></i>
          <span slot="title">Прием</span>
        </el-menu-item>
        <el-menu-item index="visit" name="visit" v-if="features('doctor_inspection')">
          <i class="el-icon-s-check"></i>
          <span slot="title">Список визитов</span>
        </el-menu-item>
        <el-menu-item index="lightVisit" v-if="features('screening_plus')">
          <i class="el-icon-mobile-phone"></i>
          <span slot="title">Доступные сессии</span>
        </el-menu-item>
        <el-menu-item index="cpanel.schedule" v-if="features('appointment')">
          <i class="el-icon-date"></i>
          <span slot="title">Бронирование</span>
        </el-menu-item>
        <div v-if="other">
          <el-menu-item index="cpanel.card" >
            <i class="el-icon-s-check"></i>
            <span slot="title">Карточка клиенту</span>
          </el-menu-item>
          <el-menu-item index="cpanel.questionnaire">
            <i class="el-icon-chat-line-square"></i>
            <span slot="title">Анкета-опросник</span>
          </el-menu-item>
          <el-menu-item index="cpanel.deviceList">
            <i class="el-icon-camera-solid"></i>
            <span slot="title">Список устройств</span>
          </el-menu-item>
          <el-menu-item index="cpanel.advice">
            <i class="el-icon-data-analysis"></i>
            <span slot="title">Результаты и рекомендации</span>
          </el-menu-item>
          <el-menu-item index="cpanel.conclusion">
            <i class="el-icon-data-analysis"></i>
            <span slot="title">Заключение диагноста</span>
          </el-menu-item>
        </div>

        <el-menu-item index="user"  v-if="features('users')">
          <i class="el-icon-user-solid"></i>
          <span slot="title">Клиенты</span>
        </el-menu-item>

        <el-menu-item index="serviceMenu" v-if="features('service_menu')">
          <i class="el-icon-odometer"></i>
          <span slot="title">Сервисное меню</span>
        </el-menu-item>

        <el-menu-item index="complexExercises" v-if="features('complex_exercises')">
          <i class="el-icon-trophy-1"></i>
          <span slot="title">Комплексы упражнений</span>
        </el-menu-item>

        <el-menu-item index="heatMarker" v-if="debug">
          <icon-heat-map :color="activeMenu === 'heatMarker' ? '#32E6BE' : '#909399'"/>
          <span slot="title">Разметчик термограмм</span>
        </el-menu-item>

        <el-menu-item index="sales" v-if="debug">
         <i class="el-icon-s-finance"></i>
          <span slot="title">Продажи</span>
        </el-menu-item>

        <el-menu-item index="cpanel.profile" v-if="debug">
          <i class="el-icon-paperclip"></i>
          <span slot="title">Профиль</span>
        </el-menu-item>

      </el-menu>

      <div @click="logout" class="the-aside__exit">
        <i class="el-icon-switch-button"></i>
      </div>

    </div>
  </el-aside>
</template>

<script>
import {mapState} from "vuex";
import IconLogo from "@/components/icons/header/Logo";
import IconHeatMap from "@/components/icons/HeatMap";

export default {
  name: "TheAside",
  computed: {
    ...mapState("menu", {
      opened: (state) => state.opened,
    }),
    ...mapState("projects", {
      projects: (state) => state.projects,
    }),
    ...mapState("menu", {
      other: (state) => state.other,
    }),
    ...mapState("auth", {
      user: (state) => state.profile,
    }),
    debug() {
      // todo попросить Славу сделать нормальную переменную в env
      return (process.env.VUE_APP_ADMIN_API_BASE_URL.indexOf('develop') + 1)
    },
    activeMenu() {
      if (this.$route.name === 'visit.lite') return 'visit.lite';
      return (this.$route.name.search('cpanel') !== -1) ? this.$route.name : this.$route.name.split('.')[0]
    },
  },
  watch: {
    opened() {
      this.show = !this.show

    }
  },
  components: {IconLogo, IconHeatMap},
  data: () => ({
    show: true
  }),
  methods: {
    goPage(index) {
      if (index === this.$route.name) {
        new Error("Navigation Duplicated")
        return;
      }
      try {
        this.$router.push({
          name: index,
          params: (index === 'cpanel.schedule') ? {date: this.$root.dateTime(new Date(), true)} : {}
        });
      } catch (err) {
        console.log("Ошибка навигации: err")
      }
    },
    features(type) {
      if (!this.user) return false
      if (this.user.features.includes(type)) {
        return true
      } else return false
    },
    logout() {
      this.$store
          .dispatch("auth/LOGOUT")
          .then(() => {
            this.$notify.success({
              title: "Удачно...",
              message: "До свидания!",
            })
          })
          .catch(() => {
            this.$notify.error({
              title: "Упс...",
              message: "Неудачная попытка 😕",
            })
          })
          .finally(() => {
            this.$router.push({name: "auth.signin"});
          })
    },
  },
}
</script>

<style scoped lang="scss">
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

.transition-box {
  margin-bottom: 10px;
  width: 200px;
  height: 100px;
  border-radius: 4px;
  background-color: #409EFF;
  text-align: center;
  color: #fff;
  padding: 40px 20px;
  box-sizing: border-box;
  margin-right: 20px;
}

.is-active {
  //border-left: 2px #dce3fd solid;
  //background: lighten(#111, 10%);
}

.logo__wrapper {
  font-weight: 700;
  overflow-x: hidden;
  white-space: nowrap;
}

.the-aside {
  width: 70px !important;
  background-color: #111;


  @media only screen and (max-width: 768px) {
    width: 40px !important;
    overflow: hidden;

  }

  z-index: 2003;
  position: relative;

  .el-menu {
    border: 0 !important;
  }

  .el-menu-item:hover {
    background: lighten(#111, 5%);
  }

  &__content {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
  }

  &__exit {
    margin-bottom: 16px;
    cursor: pointer;
    transition: all .3s ease;

    color: #fff;

    :hover {
      opacity: .5;
    }
  }

}

.logo {
  display: flex;
  justify-content: center;
  align-items: center;

  height: 60px;

  &__wrapper {
    overflow: hidden;
    display: block;
    position: relative;
  }

  &__image {
    height: 30px;
    top: 18px;
    left: 3px;
  }

  span {
    padding: 0 15px;
    color: #fff;
  }
}

.el-menu-vertical:not(.el-menu--collapse) {
  width: 250px;
  min-height: 400px;
}

.el-menu-vertical {
  background: #111;
}

@media only screen and (max-width: 500px) {
  .the-aside {
    height: 100%;
    //width: 100% !important;
    //display: none;

    &__opened {
      display: block;
      position: absolute;
    }
  }
  .el-menu-vertical:not(.el-menu--collapse) {
    width: auto;
  }
}

</style>
